import { array, number, object, SchemaOf, string, StringSchema } from 'yup';

import {
  INVALID_NAMESPACE_NAME_MESSAGE,
  isValidNamespaceName,
  NAMESPACE_NAME_MAX_LENGTH,
} from '../../../utils/namespace';

import {
  AutomaticNamespaceProvisioningFormValues,
  generateNamespace,
  isUserScope,
  NAMESPACE_ROLE_IDS,
  USER_ID_PLACEHOLDER,
} from './types';

/**
 * Largest signed 64-bit integer. The server validates the pattern against this
 * user ID so the generated namespace stays a valid name for every user.
 */
const MAX_USER_ID = '9223372036854775807';

export function createAutomaticNamespaceProvisioningValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<AutomaticNamespaceProvisioningFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    userScopes: array(number().required())
      .min(1, 'Select at least one authentication method')
      .required('Select at least one authentication method')
      .test('known-scopes', 'Unsupported authentication method', (value) =>
        (value ?? []).every(
          (scope) => scope !== undefined && isUserScope(scope)
        )
      ),
    namespacePattern: string()
      .required('Namespace pattern is required')
      .test(
        'has-user-id',
        `Namespace pattern must include ${USER_ID_PLACEHOLDER}`,
        (value) => !!value?.includes(USER_ID_PLACEHOLDER)
      )
      .test(
        'valid-namespace',
        `Generated namespace ${INVALID_NAMESPACE_NAME_MESSAGE}, and must be at most ${NAMESPACE_NAME_MAX_LENGTH} characters for any user ID`,
        (value) =>
          !value?.includes(USER_ID_PLACEHOLDER) ||
          isValidNamespaceName(generateNamespace(value, MAX_USER_ID))
      ),
    namespaceRoleId: number()
      .oneOf([...NAMESPACE_ROLE_IDS], 'Select a role')
      .required('Select a role'),
  });
}
